import { ReactNode } from 'react';
import styled from 'styled-components';

import FlagCircleUk from '@assets/icons/FlagCircleUk';
import FlagCircleUsa from '@assets/icons/FlagCircleUsa';
import { EverysetLogo } from '@assets/img';
import SaaSLogo from '@assets/img/SaaSLogo';
import { Button } from '@components/Button';
import { useClientEnvironment } from '@hooks/clientEnvironment';
import {
  SELECTED_COUNTRY_UK,
  SELECTED_COUNTRY_USA,
} from '@lib/utils/constants/selectedCountry';
import { useSignupPageContext } from '@views/auth/signup/SignupPageContext';

export const AccountCreationHeader = (): JSX.Element => {
  const { selectedCountry, goToCountrySelection, isChangeCountryEnabled } =
    useSignupPageContext();
  const { data: clientEnvironment } = useClientEnvironment();
  const { isEveryset } = clientEnvironment || {};

  return (
    <StyledHeader>
      {isEveryset ? (
        <div className='logo-container'>
          <EverysetLogo width={139} />
        </div>
      ) : (
        <div>
          <SaaSLogo />
        </div>
      )}
      {isChangeCountryEnabled && (
        <StyledChangeCountryButton onClick={goToCountrySelection}>
          {selectedCountry && flagMapper[selectedCountry]}
          <span className='button-text'>Change country</span>
        </StyledChangeCountryButton>
      )}
    </StyledHeader>
  );
};

const StyledHeader = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: space-between;

  .logo-container {
    height: 100%;
    width: 144px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const flagMapper: Record<ProductionCountry, ReactNode> = {
  [SELECTED_COUNTRY_UK]: <FlagCircleUk width={12} height={12} />,
  [SELECTED_COUNTRY_USA]: <FlagCircleUsa width={12} height={12} />,
};

const StyledChangeCountryButton = styled(Button)`
  &.ant-btn.ant-btn-default {
    width: 130px;
    height: 24px;
    border: 1px solid ${({ theme }) => theme.palette.stroke[0]};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    padding: 0;
    border-radius: 3px;

    span.button-text {
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      color: ${({ theme }) => theme.palette.text[0]};
    }
  }
`;
